export default function Overview() {
  return (
    <div className="p-4 bg-white text-sm flex justify-center flex-wrap">
      <h1 className="text-lg basis-full text-center my-2">会社概要</h1>
      <table className="my-8 text-base">
        <tbody>
          <tr>
            <td>商号</td>
            <td>株式会社サイクルミッケ</td>
          </tr>
          <tr>
            <td>商号フリガナ</td>
            <td>サイクルミッケ</td>
          </tr>
          <tr>
            <td>法人種別</td>
            <td>株式会社</td>
          </tr>
          <tr>
            <td>法人番号</td>
            <td>7180001151405</td>
          </tr>
          <tr>
            <td>本店所在地</td>
            <td>
              〒4700128
              愛知県日進市浅田平子１丁目３７０
            </td>
          </tr>
          <tr>
            <td>お問合せ先</td>
            <td><a className="text-blue-800 underline" href="https://docs.google.com/forms/d/e/1FAIpQLScC52fRbXP5ptu9NrG8xdXPWDErEPt5xu08blSmusqJO6kdxw/viewform">こちらのフォーム</a>よりお問合せお願い致します。</td>
          </tr>
        </tbody>
      </table>
    </div>
  )
}
